import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { DataRequest } from "../../models/data-request.model";

import { dataRequestListQuery } from "./data-request.gql";

interface DataRequestListResponse {
  dataRequestList: DataRequest[];
}

export interface UseGetDataRequestListProps {
  workspaceId?: string;
  enabled?: boolean;
}

export const useGetDataRequestListQuery = ({ workspaceId, enabled = true }: UseGetDataRequestListProps) => {
  const queryResult = useQuery({
    queryKey: queryKeys.dataRequests.list(workspaceId ?? ""),
    queryFn: async () => {
      if (!workspaceId) {
        throw new Error("Workspace ID is required");
      }

      const client = createOperationClient("DataRequestList");
      const data = await client.request<DataRequestListResponse>(dataRequestListQuery, {
        workspaceId,
      });

      return data.dataRequestList;
    },
    enabled: enabled && !!workspaceId,
    staleTime: 2 * 60 * 1000,
  });

  return {
    queryResult,
    loading: queryResult.isLoading,
    error: queryResult.error,
    dataRequestList: queryResult.data ?? [],
  };
};
